import LoadingScreen from 'pricing-pages-ui-components/components/LoadingScreen';
import { Redirect, Route, Switch, useLocation } from 'quartz-routing/react-router';
import { FeatureFlags } from './constants/FeatureFlags';
import { FSC_CONFIGURE, HSOC_PRICING_PREVIEW } from './constants/routes';
import { usePublicFeatureFlags } from './hooks/usePublicFeatureFlags';
import PublicFscConfigurePage from './pages/fsc-configure/PublicFscConfigurePage';
import PublicHsocPricingPage from './pages/hsoc-pricing/PublicHsocPricingPage';
import PublicIbRoutes from './PublicIbRoutes';
import { createDeferredLoadable } from './utils/createDeferredLoadable';

// Password-gated previews stay out of the main bundle.
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HsocPricingPreviewPage = createDeferredLoadable(() => import( /* webpackChunkName: "hsoc-pricing-preview" */'./pages/hsoc-pricing/HsocPricingPreviewPage').then(m => ({
  default: m.default
})));
export default function PublicRoutes() {
  const {
    featureFlags,
    loading: isHSoCPilotLoading
  } = usePublicFeatureFlags();
  const isHubSpotOnCreditsV2 = featureFlags.includes(FeatureFlags.HUBSPOT_ON_CREDITS_V2);
  const isFscConfigurePageEnabled = featureFlags.includes(FeatureFlags.FSC_CONFIGURE_PAGE);
  const {
    pathname
  } = useLocation();

  // Experimental preview: reveal the existing HSOC page behind a client-side
  // password gate, independent of the region pilot flag. Matched before the
  // pilot loading/branching below so it works regardless of viewer region.
  if (pathname === `/${HSOC_PRICING_PREVIEW}`) {
    return /*#__PURE__*/_jsx(HsocPricingPreviewPage, {});
  }
  if (isHSoCPilotLoading) {
    return /*#__PURE__*/_jsx(LoadingScreen, {});
  }

  // HSOC V2: full-width experience, no sidenav layout.
  if (isHubSpotOnCreditsV2) {
    return /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: "/",
        exact: true,
        component: PublicHsocPricingPage
      }), isFscConfigurePageEnabled && /*#__PURE__*/_jsx(Route, {
        path: `/${FSC_CONFIGURE}`,
        exact: true,
        component: PublicFscConfigurePage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/:page",
        render: ({
          location
        }) => /*#__PURE__*/_jsx(Redirect, {
          to: Object.assign({}, location, {
            pathname: '/'
          })
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(PublicIbRoutes, {});
}